import { createFileRoute, redirect } from '@tanstack/react-router';
import { EventsDocument } from 'shared/__generated__/graphql';
import { genMeta } from 'web2/app/utils/meta';
import { gql } from 'shared/__generated__/gql';
import UserEventLanding from './-user-events-landing';
import { getSessionUser } from 'web2/app/actions/getSessionUser';

export const Route = createFileRoute('/u/$username/events/')({
  component: RouteComponent,
  head: (args) => {
    return genMeta({
      title: `@${args.params.username}'s Events | PI.FYI`,
      description: `Events by @${args.params.username} on PI.FYI`,
      // TODO REMOVE WHEN EVENTS ARE LIVE
      other: [{ name: 'robots', content: 'noindex' }],
    });
  },
  beforeLoad: async ({ params }) => {
    const user = await getSessionUser();
    if (!user) {
      throw redirect({ to: '/sign-in' });
    }
    
    if (user.username !== params.username) {
      throw redirect({ to: '/events' });
    }
  },
  loader: async ({ params, context }) => {
    const { data } = await context.apolloClient.query({
      query: EventsDocument,
      variables: { 
        first: 10, 
        after: null, 
        showPastEvents: true,
        amIAttending: true,
        showOwnEvents: true
      },
    });

    return {
      events: data.events.edges.map((edge) => edge.node),
      pageInfo: data.events.pageInfo,
    };
  },
});

function RouteComponent() {
  const data = Route.useLoaderData();
  const params = Route.useParams();
  return <UserEventLanding events={data.events} pageInfo={data.pageInfo} username={params.username} />;
} 